import { render } from "./gdpr.html?vue&type=template&id=856a0722&ts=true"
import script from "./gdpr.vue?vue&type=script&lang=ts"
export * from "./gdpr.vue?vue&type=script&lang=ts"

import "./gdpr.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__